import { Component } from '@verndale/core';
import { animate } from 'motion';

class ResourceMasthead extends Component {
  isBannerVisible = false;

  setupDefaults() {
    this.dom = {
      resourceButton: this.el.querySelector<HTMLElement>('.module-header__buttons a'),
      closeButton: this.el.querySelector<HTMLElement>('.resource-banner__close-btn'),
      banner: this.el.querySelector<HTMLElement>('.resource-banner')
    };
  }

  addListeners() {
    (this.dom.resourceButton as HTMLElement)?.addEventListener('click', this.handleOpen.bind(this));
    (this.dom.closeButton as HTMLElement)?.addEventListener('click', this.handleClose.bind(this));

  }

  async handleOpen(event: Event) {
    event.preventDefault();

    await animate(this.dom.banner as HTMLElement, {
      insetBlockEnd: 0,
      opacity: 1,
      visibility: 'visible'
    }, { duration: 1 }).finished;

    this.isBannerVisible = true;

    setTimeout(() => {
      if (this.isBannerVisible) {
        this.handleClose();
      }

    }, 5000);

    window.location.href = (this.dom.resourceButton as HTMLAnchorElement).href;

  }

  async handleClose() {
    await animate(this.dom.banner as HTMLElement, {
      insetBlockEnd: '-100%',
      opacity: 0,
      visibility: 'hidden'
    }, { duration: 1 }).finished;

    this.isBannerVisible = false;
  }
}

export default ResourceMasthead;
